var _style, _g, _path, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _path2, _ellipse;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFileZip(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 34.4 44.8",
    style: {
      enableBackground: "new 0 0 34.4 44.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#D8D8D8;}\n\t.st2{fill:#68E0CE;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M0.7,44.3c-0.1,0-0.2-0.1-0.2-0.2V0.7c0-0.1,0.1-0.2,0.2-0.2h33c0.1,0,0.2,0.1,0.2,0.2v43.4 c0,0.1-0.1,0.2-0.2,0.2H0.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M33.4,1v42.8H1V1H33.4 M33.7,0h-33C0.3,0,0,0.3,0,0.7v43.4c0,0.4,0.3,0.7,0.7,0.7h33c0.4,0,0.7-0.3,0.7-0.7 V0.7C34.4,0.3,34.1,0,33.7,0L33.7,0z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M33.2,44.8h-32c-0.6,0-1.2-0.5-1.2-1.2V31.2h34.4v12.4C34.4,44.3,33.9,44.8,33.2,44.8L33.2,44.8z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 11.9,
    className: "st1",
    width: 1.2,
    height: 3.4
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 9.9,
    y: 11.9,
    className: "st1",
    width: 1.2,
    height: 3.4
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 8.4,
    y: 13,
    className: "st1",
    width: 1.2,
    height: 3.4
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 11.3,
    y: 13,
    className: "st1",
    width: 1.2,
    height: 3.4
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 12.8,
    y: 11.9,
    className: "st1",
    width: 1.2,
    height: 3.4
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 15.7,
    y: 11.9,
    className: "st1",
    width: 1.2,
    height: 3.4
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 14.3,
    y: 13,
    className: "st1",
    width: 1.2,
    height: 3.4
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 17.2,
    y: 13,
    className: "st1",
    width: 1.2,
    height: 3.4
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 18.7,
    y: 11.9,
    className: "st1",
    width: 1.2,
    height: 3.4
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 21.6,
    y: 11.9,
    className: "st1",
    width: 1.2,
    height: 3.4
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 20.1,
    y: 13,
    className: "st1",
    width: 1.2,
    height: 3.4
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 13,
    className: "st1",
    width: 1.2,
    height: 3.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M26.4,20.2H26c-0.6,0-1.1-0.5-1.1-1.1v-4.6c0-0.6,0.5-1.1,1.1-1.1h0.3c0.6,0,1.1,0.5,1.1,1.1v4.6 C27.4,19.7,26.9,20.2,26.4,20.2z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 26.2,
    cy: 15,
    rx: 0.6,
    ry: 0.6
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileZip);
export default __webpack_public_path__ + "static/media/file-zip.6bdfe5007105b954f850a8405e26bd3c.svg";
export { ForwardRef as ReactComponent };